// extracted by mini-css-extract-plugin
export default {"container":"Pipeline_container__E0olY","body":"Pipeline_body__gbXmO"};